import React, { useState, useRef, useEffect } from 'react'
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { defaultStaticRanges, defaultInputRanges } from 'react-date-range';
import { DateRangePicker as DateRangePickerPlugin } from 'react-date-range';

import Moment from 'moment'
import { useDispatch } from 'react-redux';
import { dateRangePickerDropdown } from '../../redux/actions/filterActions';
import { getCurrentThemeColor, humanize } from '../HelperFunctions';

import {
  startOfYear, endOfYear, addYears,
  isSameDay,
  startOfQuarter,
  endOfQuarter,
  subQuarters
} from "date-fns";
import useOrgDateFormat from './helperHooks/useOrgDateFormat';

const isSelected = (rangeFn, range) => {
  const definedRange = rangeFn();
  return (
    isSameDay(range.startDate, definedRange.startDate) && isSameDay(range.endDate, definedRange.endDate)
  );
};
// rangeFn contains range defined for the label & range contains date range selected in calender.
const customStaticRanges = [
  ...defaultStaticRanges,
  {
    label: "This Year",
    range: () => ({
      startDate: startOfYear(new Date()),
      endDate: endOfYear(new Date())
    }),
    isSelected(range) { isSelected(this.range, range) }
  },
  {
    label: "Last Year",
    range: () => ({
      startDate: startOfYear(addYears(new Date(), -1)),
      endDate: endOfYear(addYears(new Date(), -1))
    }),
    isSelected(range) { isSelected(this.range, range) }

  },

  {
    label: "This Quarter",
    range: () => ({
      startDate: startOfQuarter(new Date()),
      endDate: endOfQuarter(new Date())
    }),
    isSelected(range) { isSelected(this.range, range) }
  },
  {
    label: "Last Quarter",
    range: () => ({
      startDate: startOfQuarter(subQuarters(new Date(), 1)),
      endDate: endOfQuarter(subQuarters(new Date(), 1))
    }),
    isSelected(range) { isSelected(this.range, range) }
  },

]

export default function DateRangePicker(props) {
  const { onFilterChange, dateRangePicker, filters: { filter }, customKey, loading, positionClass, maxDate } = props
  const dateFormatType = useOrgDateFormat()

  let filterKey = customKey || 'date_filter'
  const [selectedDate, setSelectedDate] = useState({
    startDate: filter?.[filterKey] ? new Date(filter[filterKey].from) : new Date(),
    endDate: filter?.[filterKey] ? new Date(filter[filterKey].to) : new Date(),
    key: 'selection'
  })
  const dropdownRef = useRef(null)
  const dispatch = useDispatch()

  function handleClickOutside(event) {
    let isClickedOnInputs = event.target.id.split('-').includes(dateRangePicker)
    let isClickedOutside = dropdownRef.current && !dropdownRef.current.contains(event.target) && !isClickedOnInputs && dropdownRef.current.id === dateRangePicker
    if (isClickedOutside) {
      dispatch(dateRangePickerDropdown(false))
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [dateRangePicker]);

  const handleDateChange = (data) => {
    let filter = { filter: { ...props.filter, [filterKey]: { from: Moment(data.selection.startDate).format("YYYY/MM/DD"), to: Moment(data.selection.endDate).format("YYYY/MM/DD") } } }
    onFilterChange(filter)
    setSelectedDate(data.selection)
  }

  const renderDateFields = () => {
    return <div className={`d-flex align-items-center ml-5 ${loading && 'disabled'}`}>
      <div className="d-flex flex-column">
        {!customKey && <span>From</span>}
        <input id={`${filterKey}-from`} className='filter-date bg-white form-control form-control-sm pointer' value={filter?.[filterKey] ? Moment(filter?.[filterKey].from).format(dateFormatType) : dateFormatType} onClick={() => dispatch(dateRangePickerDropdown(filterKey))} readOnly></input>
      </div>
      <div className="d-flex flex-column">
        {!customKey && <span>To</span>}
        <input id={`${filterKey}-to`} className='filter-date bg-white form-control form-control-sm border-left-0 pointer' value={filter?.[filterKey] ? Moment(filter[filterKey].to).format(dateFormatType) : dateFormatType} onClick={() => dispatch(dateRangePickerDropdown(filterKey))} readOnly></input>
      </div>
    </div>
  }

  return (
    <div id={filterKey} className='d-flex align-items-end width-18' ref={dropdownRef}>
      {customKey ? <div className='d-flex flex-column'>
        <span className='ml-5'>{humanize(customKey)}</span>
        {renderDateFields()}
      </div> : renderDateFields()
      }
      <button className="font-size-18 bg-white border border-left-0 position-relative px-3" type="button">
        <i id={`${filterKey}-btn`} className={`las la-calendar ${loading && 'disabled'}`} onClick={() => dispatch(dateRangePickerDropdown(dateRangePicker === filterKey ? false : filterKey))}></i>
        {dateRangePicker === filterKey && <div className={`position-absolute mt-3 shadow-lg position-date-range-picker ${positionClass}`} >
          <DateRangePickerPlugin
            ranges={[selectedDate]}
            onChange={(data) => handleDateChange(data)}
            rangeColors={[getCurrentThemeColor()]}
            staticRanges={customStaticRanges}
            maxDate={maxDate}
            inputRanges={[{
              ...defaultInputRanges[0],
              label: 'past days'
            }]}
          />
        </div>
        }
      </button>
    </div>
  )
}
